/**
 * Canonical public base URL for all SHAREABLE links (referral codes, share
 * cards, social posts, deep links, etc.).
 *
 * Why a hard-coded constant?
 *   - The app runs in 3 environments: localhost, preview.emergentagent.com,
 *     and production (thecauldron.app). If we used `window.location.origin`
 *     for share/referral URLs, a practitioner copying their referral link
 *     in preview would send seekers to a URL that 404s in production.
 *   - All share links MUST always point to the canonical production domain
 *     so they survive when the recipient opens them anywhere, anytime.
 *
 * Use REACT_APP_BACKEND_URL only for API calls. Use PUBLIC_BASE for any
 * link that lives outside the runtime (clipboard, SMS, email, social).
 */
export const PUBLIC_BASE = "https://thecauldron.app";

/**
 * Founding Ambassadors cap (kept in sync with backend `rewards.ELDER_CAP`).
 * Surfaced in copy across Landing, Welcome, Elders, ElderProfile, Subscribe.
 */
export const FOUNDER_CAP = 500;
export const FOUNDER_CAP_LABEL = "500";
